import { ProjectType } from "#signup/signup.js";
//#region src/signup/projectTypeLabels.ts
const projectTypeLabels = {
	[ProjectType.Analytics]: "Analytics",
	[ProjectType.Defi]: "DeFi",
	[ProjectType.Gaming]: "Gaming",
	[ProjectType.Wallet]: "Wallet",
	[ProjectType.Security]: "Security",
	[ProjectType.Social]: "Social",
	[ProjectType.Marketplace]: "Marketplace",
	[ProjectType.InfraAndTooling]: "Infra & Tooling",
	[ProjectType.NFTs]: "NFTs",
	[ProjectType.Identity]: "Identity"
};
//#endregion
export { projectTypeLabels };

//# sourceMappingURL=projectTypeLabels.js.map